'use strict';
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _Hint_text, _IndexHint_type, _IndexHint_scope, _IndexHint_index;
var format = require('util').format;
var isDeepStrictEqual = require('deep-equal');
var isPlainObject = require('./utils').isPlainObject;
/**
 * @enum
 */
var INDEX_HINT_TYPE = {
    use: 'use',
    force: 'force',
    ignore: 'ignore',
};
/**
 * @enum
 */
var INDEX_HINT_SCOPE = {
    join: 'join',
    orderBy: 'order by',
    groupBy: 'group by',
};
var Hint = /** @class */ (function () {
    function Hint(text) {
        _Hint_text.set(this, '');
        this.text = text;
    }
    Hint.build = function (hint) {
        // eslint-disable-next-line no-use-before-define
        if (hint instanceof Hint || hint instanceof IndexHint)
            return hint;
        // eslint-disable-next-line no-use-before-define
        if (isPlainObject(hint) && hint.index)
            return IndexHint.build(hint);
        return new Hint(hint);
    };
    Object.defineProperty(Hint.prototype, "text", {
        get: function () {
            return __classPrivateFieldGet(this, _Hint_text, "f");
        },
        set: function (value) {
            if (typeof value !== 'string') {
                throw new SyntaxError("Unknown optimizer hint ".concat(value));
            }
            __classPrivateFieldSet(this, _Hint_text, value.replace(/^\s*\/\*\+|\*\/\s*$/g, '').trim(), "f");
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     * @param {Hint} hint
     * @returns {boolean}
     * @memberof Hint
     */
    Hint.prototype.isEqual = function (hint) {
        return hint instanceof Hint && this.text === hint.text;
    };
    Hint.prototype.toSqlString = function () {
        return __classPrivateFieldGet(this, _Hint_text, "f");
    };
    return Hint;
}());
_Hint_text = new WeakMap();
// MySQL only
var IndexHint = /** @class */ (function () {
    /**
     * Creates an instance of IndexHint.
     * @param {Array<string> | string} index
     * @param {INDEX_HINT_TYPE} type
     * @param {INDEX_HINT_SCOPE?} scope
     * @memberof IndexHint
     */
    function IndexHint(index, type, scope) {
        if (type === void 0) { type = INDEX_HINT_TYPE.use; }
        if (scope === void 0) { scope = ''; }
        _IndexHint_type.set(this, INDEX_HINT_TYPE.use);
        _IndexHint_scope.set(this, '');
        _IndexHint_index.set(this, []);
        this.index = index;
        this.type = type;
        this.scope = scope;
    }
    /**
     * build index hint
     *
     * @static
     * @param {object | string} obj
     * @param {string} indexHintType
     * @returns {IndexHint}
     * @example
     * build('idx_title')
     * build('idx_title', type: INDEX_HINT_TYPE.force, INDEX_HINT_SCOPE.groupBy)
     * build({
     *   index: 'idx_title',
     *   type: INDEX_HINT_TYPE.ignore,
     *   scope: INDEX_HINT_SCOPE.groupBy,
     * })
     */
    IndexHint.build = function (hint, type, scope) {
        if (typeof hint === 'string' || Array.isArray(hint)) {
            return new IndexHint(hint, type, scope);
        }
        if (isPlainObject(hint)) {
            if (hint.index != null) {
                return new IndexHint(hint.index, hint.type || type, hint.scope || scope);
            }
            for (var key in INDEX_HINT_SCOPE) {
                if (hint.hasOwnProperty(key)) {
                    var index = hint[key];
                    return new IndexHint(index, type, INDEX_HINT_SCOPE[key]);
                }
            }
        }
        if (hint instanceof IndexHint)
            return hint;
        throw new SyntaxError(format('Unknown index hint %s', hint));
    };
    Object.defineProperty(IndexHint.prototype, "index", {
        get: function () {
            return __classPrivateFieldGet(this, _IndexHint_index, "f");
        },
        set: function (values) {
            var e_1, _a;
            values = [].concat(values);
            try {
                for (var values_1 = __values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
                    var value = values_1_1.value;
                    if (typeof value !== 'string' || !value.trim()) {
                        throw new SyntaxError(format('Unknown index hint %s', value));
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            __classPrivateFieldSet(this, _IndexHint_index, values, "f");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IndexHint.prototype, "type", {
        get: function () {
            return __classPrivateFieldGet(this, _IndexHint_type, "f");
        },
        set: function (value) {
            if (!Object.values(INDEX_HINT_TYPE).includes(value)) {
                throw new SyntaxError(format('Unknown index hint type %s', value));
            }
            __classPrivateFieldSet(this, _IndexHint_type, value, "f");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IndexHint.prototype, "scope", {
        get: function () {
            return __classPrivateFieldGet(this, _IndexHint_scope, "f");
        },
        set: function (value) {
            if (value && !Object.values(INDEX_HINT_SCOPE).includes(value)) {
                throw new SyntaxError(format('Unknown index hint scope %s', value));
            }
            __classPrivateFieldSet(this, _IndexHint_scope, value || '', "f");
        },
        enumerable: false,
        configurable: true
    });
    IndexHint.prototype.toSqlString = function () {
        var _a = this, type = _a.type, scope = _a.scope, index = _a.index;
        var chunks = [type.toUpperCase(), 'INDEX'];
        if (scope) {
            chunks.push("FOR ".concat(scope.toUpperCase()));
        }
        chunks.push("(".concat(index.join(','), ")"));
        return chunks.join(' ');
    };
    /**
     *
     * @param {IndexHint} hint
     * @returns {boolean}
     * @memberof IndexHint
     */
    IndexHint.prototype.isEqual = function (hint) {
        return hint instanceof IndexHint
            && this.type === hint.type
            && this.scope === hint.scope
            && isDeepStrictEqual(this.index, hint.index);
    };
    /**
     * @static
     * @param {IndexHint} hints
     * @returns {Array<IndexHint>}
     * @memberof IndexHint
     */
    IndexHint.merge = function (hints) {
        var e_2, _a;
        if (!hints || !hints.length)
            return hints;
        var grouped = {};
        try {
            for (var hints_1 = __values(hints), hints_1_1 = hints_1.next(); !hints_1_1.done; hints_1_1 = hints_1.next()) {
                var hint = hints_1_1.value;
                var key = "".concat(hint.type, "_").concat(hint.scope);
                grouped[key] = (grouped[key] || []).concat(hint.index);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (hints_1_1 && !hints_1_1.done && (_a = hints_1.return)) _a.call(hints_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        var result = [];
        for (var key in grouped) {
            var indices = grouped[key].reduce(function (arr, index) {
                if (!arr.includes(index))
                    arr.push(index);
                return arr;
            }, []);
            var _b = __read(key.split('_'), 2), type = _b[0], scope = _b[1];
            result.push(new IndexHint(indices, type, scope));
        }
        return result;
    };
    return IndexHint;
}());
_IndexHint_type = new WeakMap(), _IndexHint_scope = new WeakMap(), _IndexHint_index = new WeakMap();
module.exports = {
    Hint: Hint,
    IndexHint: IndexHint,
    INDEX_HINT_TYPE: INDEX_HINT_TYPE,
    INDEX_HINT_SCOPE: INDEX_HINT_SCOPE,
    INDEX_HINT_SCOPE_TYPE: Object.keys(INDEX_HINT_SCOPE).reduce(function (result, entry) {
        result[entry] = entry;
        return result;
    }, {}),
};
//# sourceMappingURL=hint.js.map